import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export function DuplicateDialog({ book, onClose, onDone }) {
  const [title, setTitle] = useState("");
  const [mode, setMode] = useState("edition");
  useEffect(() => { if (book) { setTitle(`${book.title} (new edition)`); setMode("edition"); } }, [book]);
  const go = async () => {
    try {
      await api.post(`/books/${book.id}/duplicate`, { title, mode });
      toast.success("Project duplicated");
      onClose(); onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!book} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#131B2A] border-slate-800" data-testid="duplicate-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Duplicate project</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Input value={title} onChange={(e) => setTitle(e.target.value)} data-testid="duplicate-title-input" />
          {[["edition", "New edition", "Copies details and the current manuscript as version 1."], ["next_book", "Next book in series", "Copies details only, increments the book number, no manuscript."]].map(([k, l, d]) => (
            <label key={k} className={`block panel p-4 cursor-pointer ${mode === k ? "border-amber-500/50" : ""}`} data-testid={`duplicate-mode-${k}`}>
              <input type="radio" className="mr-2 accent-amber-500" checked={mode === k} onChange={() => setMode(k)} />{l}
              <p className="text-xs text-slate-400 mt-1 ml-5">{d}</p>
            </label>
          ))}
        </div>
        <DialogFooter><Button onClick={go} className="bg-amber-600 hover:bg-amber-500" data-testid="duplicate-confirm">Duplicate</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
